// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  GroupRunMode,
} from "./types";

export default {
  cohortAssignmentId: __t.u64(),
  name: __t.string(),
  memberEmails: __t.array(__t.string()),
  leaderEmail: __t.string(),
  get mode() {
    return GroupRunMode;
  },
  allowLateJoin: __t.bool(),
  autoStallSeconds: __t.u32(),
};
